import React, { useEffect, useRef, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import RemoveCircle from "@mui/icons-material/RemoveCircle";
import Clear from "@mui/icons-material/Clear";
import Add from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import WarningIcon from "@mui/icons-material/Warning";
// eslint-disable-next-line no-unused-vars
import { CameraSettings, Presets, SnapshotCamera } from "orion-components/CBComponents/Icons";
import PropTypes from "prop-types";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import NestedMenu from "./Components/NestedMenu";
import { getTranslation } from "orion-components/i18n";
import { useDispatch, useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { cameraService } from "client-app-core";
import { removeDockedCameraAndState, addCameraToDockMode } from "orion-components/Dock/Cameras/actions";
import { canManageByApplication } from "orion-components/Profiles/Selectors";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { canAccessPtzLockMenu, getIsCameraExplicitlyLocked } from "../../../../GlobalData/PTZPrivilege/selectors";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
import { updateComponentInstance } from "orion-components/SharedComponents/ComponentState/redux/actions";
import { makeSelectComponentProp } from "../../../../SharedComponents/ComponentState/redux/selectors";
import CameraSettingsDialog from "./Components/CameraSettingsDialog";
import AddPresetDialog from "./Components/AddPresetDialog";
import { handleSnapshotCapture } from "./snapshotCapture";

const COMPONENT_KEY = "cbComponents.newVideoPlayer.videoPlayerContainer";

const MainMenu = ({
	getMenuState,
	camera,
	readOnly,
	inDock,
	isInVideoWall,
	removeFromWall,
	clusterProps,
	isOnAlertProfile,
	hideRemoveFromWall,
	instanceId
}) => {
	const dispatch = useDispatch();

	const [displayMenu, setDisplayMenu] = useState(null);
	const [displayNestedMenu, setDisplayNestedMenu] = useState(false);
	const [nestedMenuIsFor, setNestedMenuIsFor] = useState("");
	const [presets, setPresets] = useState([]);
	const isLocked = useSelector(state => getIsCameraExplicitlyLocked(state, { cameraId: camera.id }));
	const timeFormat = useSelector(state => state.appState.global.timeFormat);
	const locale = useSelector(state => state.i18n.locale);
	// eslint-disable-next-line no-unused-vars
	const [nestedMenuContent, setNestedMenuContent] = useState([]);
	const dir = useSelector(state => getDir(state));
	const canManage = useSelector(state => canManageByApplication(state, "camera-wall-app", "manage"));
	const canShowLockMenu = useSelector(state => canAccessPtzLockMenu(state, { cameraId: camera.id }));
	const [showCameraSettings, setShowCameraSettings] = useState(false);
	const [showAddPresetDialog, setShowAddPresetDialog] = useState(false);
	const [isSavingPreset, setIsSavingPreset] = useState(false);
	const [isPresetValid, setIsPresetValid] = useState(true);
	const mainMenuRef = useRef(null);

	useEffect(() => {
		if (!instanceId) return; // optional guard
		dispatch(
			updateComponentInstance(COMPONENT_KEY, instanceId, { components: { mainMenu: { showControls: true } } })
		);
	}, [dispatch, instanceId]);

	const setupPresets = async () => {
		const response = await cameraService.getPresets(camera.id);
		const data = response?.result?.data;
		const hasValidData = response?.result?.status === "SUCCESS" && Array.isArray(data);

		if (!hasValidData) {
			setIsPresetValid(false);
			return;
		};
		setIsPresetValid(true);
		setPresets(data);
	};
	const dockedCameras = useSelector(state => state.appState.dock?.cameraDock?.dockedCameras);

	const hasCapability = capability => {
		return camera.entityData.properties.features && camera.entityData.properties.features.includes(capability);
	};

	const user = useSelector(state => state?.session?.user?.profile);
	const canControl =
		!readOnly &&
		user.integrations &&
		user.integrations.find(int => int.intId === camera.feedId) &&
		user.integrations.find(int => int.intId === camera.feedId).permissions &&
		user.integrations.find(int => int.intId === camera.feedId).permissions.includes("control");

	useEffect(() => {
		setupPresets();
	}, []);

	const mainMenuShowControls = useSelector(
		makeSelectComponentProp(COMPONENT_KEY, instanceId, "components.mainMenu.showControls")
	);

	const canChangeSettings = hasCapability("focus") || hasCapability("iris");
	const canCreatePreset = hasCapability("createPreset");

	// Currently all players except avigilon support client side snapshot capture
	const supportsClientSnapshot = camera?.player?.type !== "avigilon";
	// We still need to check camera features to see if the integration supports server side snapshot
	const supportsServerSnapshot = hasCapability("snapshot");

	const menuItems = [
		{
			id: 1,
			canAccessMenu: hasCapability("control") && canControl,
			item: mainMenuShowControls
				? getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.hideControls")
				: getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.showControls"),
			icon: mainMenuShowControls ? (
				<VisibilityIcon sx={{ width: 14, height: 12, color: "#4DB5F4" }} />
			) : (
				<VisibilityOffIcon sx={{ width: 14, height: 12, color: "#948E8E", opacity: "50%" }} />
			),
			action: () => {
				dispatch(
					updateComponentInstance(COMPONENT_KEY, instanceId, {
						components: { mainMenu: { showControls: !mainMenuShowControls } }
					})
				);
			},
			hasNestedMenu: false
		},
		// {
		// 	id: 2,
		// 	item: "Detach Viewer",
		// 	icon: (
		// 		<img
		// 			alt="detach_viewer"
		// 			src={require(`orion-components/img/app-icons/icon-open.png`)}
		// 			style={{ width: 14, height: 12 }}
		// 		/>
		// 	),
		// 	action: () => {},
		// 	hasNestedMenu: true
		// },
		// {
		// 	id: 3,
		// 	item: "Remove Viewer",
		// 	icon: (
		// 		<IconButton
		// 			style={{
		// 				color: "black",
		// 				padding: 0,
		// 				boxShadow: "0px 0px 3px #00000026",
		// 				width: 15,
		// 				height: 15,
		// 				borderRadius: "50%",
		// 				opacity: 1,
		// 				transform: "matrix(0, 1, -1, 0, 0, 0)",
		// 				backgroundColor: "#948E8E",
		// 				marginLeft: 4
		// 			}}
		// 		>
		// 			<CloseIcon sx={{ width: 8.5, height: 8.5 }} />
		// 		</IconButton>
		// 	),
		// 	action: () => {},
		// 	hasNestedMenu: false
		// },
		{
			id: 4,
			item: "divider"
		},
		// {
		// 	id: 5,
		// 	item: "Create Situation",
		// 	icon: <WarningIcon sx={{ width: 18.66, height: 18.66, color: "#948E8E" }} />,
		// 	action: () => {},
		// 	hasNestedMenu: false
		// },
		// {
		// 	id: 6,
		// 	item: "Show Situations",
		// 	icon: <VisibilityOffIcon sx={{ width: 18.66, height: 18.66, color: "#948E8E" }} />,
		// 	action: () => {},
		// 	hasNestedMenu: false
		// },
		// {
		// 	id: 8,
		// 	item: "divider"
		// },
		{
			id: 9,
			canAccessMenu: canChangeSettings,
			item: getTranslation("global.profiles.widgets.cameras.camCard.cameraSettings"),
			icon: (
				<div style={{ display: "flex", alignItems: "center" }}>
					<CameraSettings />
				</div>
			),
			action: () => {
				setShowCameraSettings(true);
			},
			hasNestedMenu: false
		},
		{
			id: 10,
			item: getTranslation("global.profiles.widgets.cameras.camCard.presets"),
			canAccessMenu: hasCapability("control") && canControl,
			icon: (
				<div style={{ opacity: "50%" }}>
					<Presets />
				</div>
			),
			action: async () => {
				setNestedMenuIsFor("presets");
				setDisplayNestedMenu(true);
				setNestedMenuContent(presets);
				getMenuState(true);
			},
			hasNestedMenu: true
		},
		{
			id: 11.1,
			item: getTranslation("global.profiles.widgets.cameras.camCard.addToDock"),
			canAccessMenu: !inDock,
			icon: <Add sx={{ width: 14, height: 12, color: "#FFFFFF", opacity: "50%" }} />,
			action: () => {
				dispatch(addCameraToDockMode(camera, true));
			},
			hasNestedMenu: false
		},
		{
			id: 11,
			item: getTranslation("global.profiles.widgets.cameras.camCard.removeFromDock"),
			canAccessMenu: inDock,
			icon: <Clear sx={{ width: 14, height: 12, color: "#FFFFFF", opacity: "50%" }} />,
			action: () => {
				const dockIndex = dockedCameras.lastIndexOf(camera.id);
				dispatch(removeDockedCameraAndState(dockIndex, dockedCameras));
			},
			hasNestedMenu: false
		},
		{
			id: 12,
			item: getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.removeFromWall"),
			canAccessMenu: canManage && isInVideoWall && !isOnAlertProfile && !hideRemoveFromWall,
			icon: <Clear sx={{ width: 14, height: 12, color: "#FFFFFF", opacity: "50%" }} />,
			action: () => {
				const { currentRow, currentCol } = clusterProps;
				removeFromWall(currentRow, currentCol);
			},
			hasNestedMenu: false
		},
		{
			id: 13,
			canAccessMenu: canShowLockMenu,
			item: isLocked ? "Unlock" : "Lock",
			icon: isLocked ? (
				<LockOpenIcon sx={{ width: 14, height: 12, color: "#4DB5F4" }} />
			) : (
				<LockIcon sx={{ width: 14, height: 12, color: "#948E8E", opacity: "50%" }} />
			),
			action: () => {
				if (isLocked) {
					// Explicit UNLOCK
					cameraService.clearExplicitLock(camera.id, (err, res) => {
						if (err || !res || res.success === false) {
							const errorMessage =
								(err && err.message) || (res && res.message) || "Failed to clear explicit PTZ lock.";

							dispatch(createUserFeedback(errorMessage, null, true));
							return;
						}

						const successMessage = res.message || "Explicit PTZ lock cleared successfully.";

						dispatch(createUserFeedback(successMessage, null, false));
					});
				} else {
					// Explicit LOCK
					cameraService.setExplicitLock(camera.id, (err, res) => {
						if (err || !res || res.success === false) {
							const errorMessage =
								(err && err.message) || (res && res.message) || "Failed to apply explicit PTZ lock.";

							dispatch(createUserFeedback(errorMessage, null, true));
							return;
						}

						const successMessage = res.message || "Explicit PTZ lock applied successfully.";

						dispatch(createUserFeedback(successMessage, null, false));
					});
				}

				setDisplayMenu(null);
				getMenuState(false);
			},
			hasNestedMenu: false
		},
		{
			id: 14,
			canAccessMenu: supportsClientSnapshot || supportsServerSnapshot,
			item: getTranslation("global.profiles.widgets.cameras.camCard.captureSnapshot"),
			icon: (
				<div>
					<SnapshotCamera />
				</div>
			),
			action: () => {
				handleSnapshotCapture({
					camera,
					mainMenuRef,
					supportsClientSnapshot,
					supportsServerSnapshot,
					cameraService,
					dispatch,
					createUserFeedback,
					getTranslation,
					timeFormat,
					locale
				});
			},
			hasNestedMenu: false
		}
	];

	const handlePopoverClose = () => {
		setDisplayMenu(null);
		getMenuState(false);
	};

	const closeNestedMenu = () => {
		setDisplayNestedMenu(false);
		setDisplayMenu(true);
	};

	const handleAddPreset = () => {
		setShowAddPresetDialog(true);
	};

	const handleSavePresetError = (err, res) => {
		const errorMessage =
			(err && err.message) ||
			(res && res.message) ||
			getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.failedSavePreset");
		dispatch(createUserFeedback(errorMessage, null, true));
		setShowAddPresetDialog(false);
	};

	const handleSavePresetSuccess = res => {
		setShowAddPresetDialog(false);
		setupPresets();
		dispatch(
			createUserFeedback(
				res.message ||
					getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.successSavePreset"),
				null,
				false
			)
		);
	};

	const handleSavePreset = selectedPresetValue => {
		if (!selectedPresetValue) return;

		setIsSavingPreset(true);
		const parsedPresetNumber = Number.parseInt(selectedPresetValue, 10);
		const presetNumber = Number.isInteger(parsedPresetNumber) ? parsedPresetNumber : selectedPresetValue;

		cameraService.savePreset(camera.id, presetNumber, (err, res) => {
			setIsSavingPreset(false);

			if (err || !res || res.success === false) {
				handleSavePresetError(err, res);
				return;
			}

			handleSavePresetSuccess(res);
		});
	};

	return (
		<div dir={dir} ref={mainMenuRef}>
			<IconButton
				style={{ color: "#FFF", width: "auto", padding: 0, height: "100%" }}
				onClick={() => {
					setDisplayMenu(true);
					getMenuState(true);
				}}
			>
				<MoreVertIcon />
			</IconButton>
			<div
				style={{
					display: displayMenu !== null ? "block" : "none",
					position: "absolute",
					top: 0,
					color: "#fff",
					visibility: displayNestedMenu ? "hidden" : "visible",
					zIndex: 9999
				}}
				onMouseLeave={handlePopoverClose}
			>
				<div
					style={{
						width: 160,
						minHeight: 160,
						maxHeight: 280,
						overflowY: "auto",
						overflow: "hidden",
						background: "#232223",
						boxShadow: "0px 0px 6px #0000009A",
						opacity: 1,
						backdropFilter: "blur(3px)",
						WebkitBackdropFilter: "blur(3px)",
						cursor: !canControl ? "default" : "pointer",
						borderRadius: 8,
						padding: "8px 0"
					}}
				>
					{menuItems.map((value, index) => {
						if (value.item !== "divider") {
							if (value.canAccessMenu) {
								return (
									<div
										key={index}
										className={`bcc-main-menu ${!canControl && "disabled"}`}
										onClick={value.action}
										style={{
											width: "100%",
											display: "flex",
											flexDirection: "row",
											alignItems: "center",
											justifyContent: "space-between",
											padding: "4px 5px",
											fontSize: 10,
											cursor: "pointer",
											boxSizing: "border-box"
										}}
									>
										<div style={{ display: "flex", alignItems: "center", width: 14, flexShrink: 0 }}>{value.icon}</div>
										<div
											style={{
												flex: "1 1 auto",
												display: "flex",
												alignItems: "center",
												marginLeft: 16,
												overflow: "hidden",
												whiteSpace: "nowrap",
												textOverflow: "ellipsis",
												fontFamily: "Roboto"
											}}
										>
											{value.item}
										</div>
										{value.hasNestedMenu && (
											<div style={{ display: "flex", alignItems: "center" }}>
												<KeyboardArrowRightIcon sx={{ width: 12, height: 12, color: "#fff" }} />
											</div>
										)}
									</div>
								);
							}
						} else {
							return (
								<div
									key={index}
									style={{
										width: "90%",
										height: 1,
										backgroundColor: "#444",
										margin: "8px auto"
									}}
								></div>
							);
						}
					})}
				</div>
			</div>
			{displayNestedMenu && (
				<div
					style={{
						zIndex: 9999,
						display: displayNestedMenu !== null ? "block" : "none",
						position: "absolute",
						top: 0,
						color: "#fff"
					}}
					onMouseLeave={() => {
						setDisplayNestedMenu(false);
					}}
				>
					<NestedMenu
						nestedMenuContent={nestedMenuContent}
						closeNestedMenu={closeNestedMenu}
						nestedMenuIsFor={nestedMenuIsFor}
						cameraId={camera.id}
						canCreatePreset={canCreatePreset}
						onAddPreset={handleAddPreset}
						closeMainMenu={() => {
							setDisplayMenu(null);
						}}
						isPresetValid={isPresetValid}
					/>
				</div>
			)}
			{showCameraSettings && (
				<div>
					<CameraSettingsDialog
						open={showCameraSettings}
						onClose={() => setShowCameraSettings(false)}
						camera={camera}
					/>
				</div>
			)}
			<AddPresetDialog
				open={showAddPresetDialog}
				onClose={() => setShowAddPresetDialog(false)}
				onSave={handleSavePreset}
				isSaving={isSavingPreset}
				presets={presets}
				isPresetValid={isPresetValid}
			/>
		</div>
	);
};

const defaultProps = {
	readOnly: false
};

MainMenu.propTypes = {
	getMenuState: PropTypes.func.isRequired,
	camera: PropTypes.object.isRequired,
	readOnly: PropTypes.bool,
	inDock: PropTypes.bool,
	isInVideoWall: PropTypes.bool,
	removeFromWall: PropTypes.func
};
MainMenu.defaultProps = defaultProps;

export default MainMenu;
